import React from 'react'
import GameCard from './game-card'
import moment from 'moment/moment'

export default function UpcomingGames(props) {
  const { upcomingEvents, unseen, gamesSelector, isLoading } = props

  const groupedEvents = (events) => {
    if (!events.length) return null

    const grouped = events.reduce((g, e) => {
      g[e.date] = g[e.date] || []
      g[e.date].push(e)
      return g
    }, Object.create(null))

    return Object.keys(grouped)
      .sort((prev, next) => moment(prev).diff(moment(next)))
      .reduce((a, v) => { return {...a, [v]: grouped[v]} }, {})
  }

  const eventSelected = (event) => {
    if (!gamesSelector.enabled) return

    return gamesSelector.selected.indexOf(event.id) != -1
  }

  return(
    <div className='panel-body' id='reservation-cards-panel'>
      { isLoading && <div className='animated-spinner'></div> }
      <div className={`card-deck${isLoading ? ' isLoading' : ''}`}>
        { !!upcomingEvents.length &&
          Object.keys(groupedEvents(upcomingEvents)).map((key, index) => {
            return (
              <div class='upcoming-day' key={index}>
                <div className='upcoming-header-container'>
                  <span className='upcoming-section-header'>{moment(key).format('dddd, MMMM Do YYYY')}</span>
                </div>
                {
                  groupedEvents(upcomingEvents)[key].map((event, i) => {
                    return (
                      <GameCard
                        selected={eventSelected(event)}
                        onGamesSelect={props.onGamesSelect}
                        event={event}
                        eventIndex={i}
                        newLocations={props.newLocations}
                        unseen={event.channel_id && unseen.includes(event.channel_id)}
                        onUpdateWithFacility={props.onUpdateWithFacility}
                        key={i}
                        onTodoChange={props.onTodoChange}
                        onShowGameModal={props.onShowGameModal}
                        onEditGame={props.onEditGame}
                      /> 
                    )
                  })
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}
